import { Typography } from "@mui/material";

import { ChatMessage, PreDefinedConstraints } from "../../types";
import { ChatMessageList } from "./ChatMessageList";
import { UserMessage } from "./messages/UserMessage";
import { ChatAvatar } from "./primitives/ChatAvatar";
import { MessageBubble } from "./primitives/MessageBubble";
import { TodoListMessage } from "./transient/TodoListMessage";

interface ChatContentProps {
  chatMessages: ChatMessage[];
  currentQuestion?: string;
  currentPreSetConstraints?: PreDefinedConstraints;
  isStreaming: boolean;
  todoItems: string[];
}

export const ChatContent = ({
  chatMessages,
  currentQuestion,
  currentPreSetConstraints,
  isStreaming,
  todoItems,
}: ChatContentProps) => {
  return (
    <>
      <ChatMessageList messages={chatMessages} />

      {currentQuestion && !isStreaming && todoItems.length !== 0 && (
        // Simple "thinking" state
        <>
          <MessageBubble variant="user" avatar={<ChatAvatar variant="user" />}>
            <Typography variant="body1">{currentQuestion}</Typography>
          </MessageBubble>
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            Analyzing growth data...
          </Typography>
        </>
      )}

      {isStreaming && currentQuestion && (
        <>
          <UserMessage content={currentQuestion} preSetConstraints={currentPreSetConstraints} />
          <TodoListMessage todoItems={todoItems} />
        </>
      )}
    </>
  );
};
